import { Select } from 'semantic-ui-react'
import * as React from 'react'

interface View {
  _id: string
  name: string
  title: string
}

interface Props {
  views: View[]
  currentViewName: string
  isLoading: boolean
  onViewChange(viewName: string): void
  filtersElement?: React.ReactNode
  description?: string
}

export default function FunnelViewsHeader(props: Props) {
  const {
    views,
    currentViewName,
    isLoading,
    onViewChange,
    filtersElement,
    description,
  } = props

  return (
    <div className="relative z-20 flex flex-wrap items-center gap-2 bg-white px-6 py-4">
      <div className="flex items-center">
        <label className="pr-2 font-semibold">View:</label>
        <Select
          placeholder="Select a view"
          loading={isLoading}
          value={currentViewName}
          options={views.map((view) => ({
            key: view._id,
            text: view.title,
            value: view.name,
          }))}
          onChange={(_, data) => {
            if (typeof data.value === 'string') {
              onViewChange(data.value)
            }
          }}
        />
      </div>

      {filtersElement && (
        <div className="ml-12 flex items-center gap-2">
          <label className="pr-2 font-semibold">Show:</label>
          {filtersElement}
        </div>
      )}

      <div className="grow" />

      {description && (
        <div className="text-sm text-slate-500">{description}</div>
      )}
    </div>
  )
}
